// tslint:disable
//MD5加密的方法
export function MD5(s){
    function L(k,d){return(k<<d)|(k>>>(32-d));}
    function K(G,k){var I,d,F,H,x;F=(G&2147483648);H=(k&2147483648);I=(G&1073741824);d=(k&1073741824);x=(G&1073741823)+(k&1073741823);if(I&d){return(x^2147483648^F^H);}if(I|d){if(x&1073741824){return(x^3221225472^F^H);}else{return(x^1073741824^F^H);}}else{return(x^F^H);}}
    function r(d,F,k){return(d&F)|((~d)&k);}
    function q(d,F,k){return(d&k)|(F&(~k));}
    function p(d,F,k){return(d^F^k);}
    function n(d,F,k){return(F^(d|(~k)));}
    function u(G,F,aa,Z,k,H,I){G=K(G,K(K(r(F,aa,Z),k),I));return K(L(G,H),F);}
    function f(G,F,aa,Z,k,H,I){G=K(G,K(K(q(F,aa,Z),k),I));return K(L(G,H),F);}
    function D(G,F,aa,Z,k,H,I){G=K(G,K(K(p(F,aa,Z),k),I));return K(L(G,H),F);}
    function t(G,F,aa,Z,k,H,I){G=K(G,K(K(n(F,aa,Z),k),I));return K(L(G,H),F);}
    function e(G){
      var Z;var F=G.length;var x=F+8;var k=(x-(x%64))/64;var I=(k+1)*16;var aa=Array(I-1);var d=0;var H=0;while(H<F){Z=(H-(H%4))/4;d=(H%4)*8;aa[Z]=(aa[Z]|(G.charCodeAt(H)<<d));H++;}Z=(H-(H%4))/4;d=(H%4)*8;aa[Z]=aa[Z]|(128<<d);aa[I-2]=F<<3;aa[I-1]=F>>>29;return aa;
    }
    function B(x){
      var k="",F="",G,d;for(d=0;d<=3;d++){G=(x>>>(d*8))&255;F="0"+G.toString(16);k=k+F.substr(F.length-2,2);}return k;
    }
    function J(k){
      k=k.replace(/rn/g,"n");var d="";for(var F=0;F<k.length;F++){var x=k.charCodeAt(F);if(x<128){d+=String.fromCharCode(x);}else{if((x>127)&&(x<2048)){d+=String.fromCharCode((x>>6)|192);d+=String.fromCharCode((x&63)|128);}else{d+=String.fromCharCode((x>>12)|224);d+=String.fromCharCode(((x>>6)&63)|128);d+=String.fromCharCode((x&63)|128);}}}return d;}var C=Array();var P,h,E,v,g,Y,X,W,V;var S=7,Q=12,N=17,M=22;var A=5,z=9,y=14,w=20;var o=4,m=11,l=16,j=23;var U=6,T=10,R=15,O=21;s=J(s);C=e(s);Y=1732584193;X=4023233417;W=2562383102;V=271733878;for(P=0;P<C.length;P+=16){h=Y;E=X;v=W;g=V;Y=u(Y,X,W,V,C[P+0],S,3614090360);V=u(V,Y,X,W,C[P+1],Q,3905402710);W=u(W,V,Y,X,C[P+2],N,606105819);X=u(X,W,V,Y,C[P+3],M,3250441966);Y=u(Y,X,W,V,C[P+4],S,4118548399);V=u(V,Y,X,W,C[P+5],Q,1200080426);W=u(W,V,Y,X,C[P+6],N,2821735955);X=u(X,W,V,Y,C[P+7],M,4249261313);Y=u(Y,X,W,V,C[P+8],S,1770035416);V=u(V,Y,X,W,C[P+9],Q,2336552879);W=u(W,V,Y,X,C[P+10],N,4294925233);X=u(X,W,V,Y,C[P+11],M,2304563134);Y=u(Y,X,W,V,C[P+12],S,1804603682);V=u(V,Y,X,W,C[P+13],Q,4254626195);W=u(W,V,Y,X,C[P+14],N,2792965006);X=u(X,W,V,Y,C[P+15],M,1236535329);Y=f(Y,X,W,V,C[P+1],A,4129170786);V=f(V,Y,X,W,C[P+6],z,3225465664);W=f(W,V,Y,X,C[P+11],y,643717713);X=f(X,W,V,Y,C[P+0],w,3921069994);Y=f(Y,X,W,V,C[P+5],A,3593408605);V=f(V,Y,X,W,C[P+10],z,38016083);W=f(W,V,Y,X,C[P+15],y,3634488961);X=f(X,W,V,Y,C[P+4],w,3889429448);Y=f(Y,X,W,V,C[P+9],A,568446438);V=f(V,Y,X,W,C[P+14],z,3275163606);W=f(W,V,Y,X,C[P+3],y,4107603335);X=f(X,W,V,Y,C[P+8],w,1163531501);Y=f(Y,X,W,V,C[P+13],A,2850285829);V=f(V,Y,X,W,C[P+2],z,4243563512);W=f(W,V,Y,X,C[P+7],y,1735328473);X=f(X,W,V,Y,C[P+12],w,2368359562);Y=D(Y,X,W,V,C[P+5],o,4294588738);V=D(V,Y,X,W,C[P+8],m,2272392833);W=D(W,V,Y,X,C[P+11],l,1839030562);X=D(X,W,V,Y,C[P+14],j,4259657740);Y=D(Y,X,W,V,C[P+1],o,2763975236);V=D(V,Y,X,W,C[P+4],m,1272893353);W=D(W,V,Y,X,C[P+7],l,4139469664);X=D(X,W,V,Y,C[P+10],j,3200236656);Y=D(Y,X,W,V,C[P+13],o,681279174);V=D(V,Y,X,W,C[P+0],m,3936430074);W=D(W,V,Y,X,C[P+3],l,3572445317);X=D(X,W,V,Y,C[P+6],j,76029189);Y=D(Y,X,W,V,C[P+9],o,3654602809);V=D(V,Y,X,W,C[P+12],m,3873151461);W=D(W,V,Y,X,C[P+15],l,530742520);X=D(X,W,V,Y,C[P+2],j,3299628645);Y=t(Y,X,W,V,C[P+0],U,4096336452);V=t(V,Y,X,W,C[P+7],T,1126891415);W=t(W,V,Y,X,C[P+14],R,2878612391);X=t(X,W,V,Y,C[P+5],O,4237533241);Y=t(Y,X,W,V,C[P+12],U,1700485571);V=t(V,Y,X,W,C[P+3],T,2399980690);W=t(W,V,Y,X,C[P+10],R,4293915773);X=t(X,W,V,Y,C[P+1],O,2240044497);Y=t(Y,X,W,V,C[P+8],U,1873313359);V=t(V,Y,X,W,C[P+15],T,4264355552);W=t(W,V,Y,X,C[P+6],R,2734768916);X=t(X,W,V,Y,C[P+13],O,1309151649);Y=t(Y,X,W,V,C[P+4],U,4149444226);V=t(V,Y,X,W,C[P+11],T,3174756917);W=t(W,V,Y,X,C[P+2],R,718787259);X=t(X,W,V,Y,C[P+9],O,3951481745);Y=K(Y,h);X=K(X,E);W=K(W,v);V=K(V,g);
      }
      var i=B(Y)+B(X)+B(W)+B(V);return i.toLowerCase();
  }
  var hls,countTime=0;
  function hlsplay(_player){
    if(Hls.isSupported()) {
      if (hls) {hls.destroy()};
      hls = new Hls();
      hls.loadSource(hlsUrl);
      hls.attachMedia(_player);
      hls.on(Hls.Events.MANIFEST_PARSED,function() {
        _player.play();
      });
      hls.on(Hls.Events.ERROR, function (event, data) {
        if (!data.fatal && hls) {
          switch(data.type) {
          case Hls.ErrorTypes.NETWORK_ERROR:
          // try to recover network error
            console.log("fatal network error encountered, try to recover");
              console.log("countTime",countTime);
            if (countTime<5) {
              hls.startLoad();
              countTime++;
            }else{
              hls.stopLoad();
            }
            break;
          case Hls.ErrorTypes.MEDIA_ERROR:
            console.log("fatal media error encountered, try to recover");
            hls.recoverMediaError();
            break;
          default:
          // cannot recover
            console.log("hls destroy");
            hls.stopLoad();
            isReloadVideo=false;
            break;
          }
        }else{
          // VideoPage.infoDialog('无法连接视频流，请重试');
          console.log("hls destroy");
          hls.stopLoad();
          isReloadVideo=false;
        }
      });
    }
  }

  Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
    get: function(){
      return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
    }
  })

  var getSpeicalTime = function () {
      var now = new Date;
      now.setMinutes (now.getMinutes () - 10);
      return now;
  }

  //  获取url中参数 start
  function GetRequest() {
    //修正百分号问题
    var url = decodeURIComponent(location.search.replace("%%","%25%")); //获取url中"?"符后的字串
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
      var str = url.substr(1);
      strs = str.split("&");
      for(var i = 0; i < strs.length; i ++) {
        theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);
      }
    }
    return theRequest;
  }

  //  获取url中参数 stop

  //字符串倒序
  export const reverse = (str) => {
      return str.split('').reverse().join('');
  };


  //  转数组
  export function Str2Bytes(str)
  {
         var pos = 0;
         var len = str.length;
         if(len %2 != 0)
         {
            return null;
         }
         len /= 2;
         var hexA = new Array();
         for(var i=0; i<len; i++)
         {
            var s = str.substr(pos, 2);
            var v = parseInt(s, 16);
            hexA.push(v);
            pos += 2;
         }
         return hexA;
  }

  // 转16进制
  var keyStr = "ABCDEFGHIJKLMNOP" +
             "QRSTUVWXYZabcdef" +
             "ghijklmnopqrstuv" +
             "wxyz0123456789+/" +
             "=";

  export function encode64(input) {
   //input = unicodetoBytes(input);
   var output = "";
   var chr1, chr2, chr3 = "";
   var enc1, enc2, enc3, enc4 = "";
   var i = 0;

   do {
      chr1 = input[i++];
      chr2 = input[i++];
      chr3 = input[i++];

      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
         enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
         enc4 = 64;
      }

      output = output +
         keyStr.charAt(enc1) +
         keyStr.charAt(enc2) +
         keyStr.charAt(enc3) +
         keyStr.charAt(enc4);
      chr1 = chr2 = chr3 = "";
      enc1 = enc2 = enc3 = enc4 = "";
   } while (i < input.length);

   return output;
  }

  var isNumber=function(keyCode){
    // 数字
    if (keyCode >= 48 && keyCode <= 57) {
      return true;
    }
      // 小数字键盘
    if (keyCode >= 96 && keyCode <= 105) {
      return true;
    }
      //tab Backspace, del, 左右方向键
    if (keyCode == 9||keyCode == 8|| keyCode == 32 || keyCode == 46 || keyCode == 37 || keyCode == 39) {
      return true;
    }
    return false;
  }

  var isNumOrChar=function(keyCode){

    // 数字
    if (keyCode >= 48 && keyCode <= 57) {
      return true;
    }
      // 小数字键盘
    if (keyCode >= 96 && keyCode <= 105) {
      return true;
    }
    if(keyCode >= 65 && keyCode <= 90){
      return true;
    }
    //tab Backspace, del, 左右方向键
    if (keyCode == 9||keyCode == 8|| keyCode == 32 || keyCode == 46 || keyCode == 37 || keyCode == 39) {
      return true;
    }
    return false;
  }



  /*
   *
   * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
   * in FIPS PUB 180-1
   *
   * By lizq
   *
   * 2006-11-11
   *
   */
  /*
   *
   * Configurable variables.
   *
   */
  var hexcase = 0; /* hex output format. 0 - lowercase; 1 - uppercase */
  var chrsz = 8; /* bits per input character. 8 - ASCII; 16 - Unicode */
  /*
   *
   * The main function to calculate message digest
   *
   */
  export function hex_sha1(s){

      return binb2hex(core_sha1(AlignSHA1(s)));

  }

  /*
   *
   * Perform a simple self-test to see if the VM is working
   *
   */
  function sha1_vm_test(){

      return hex_sha1("abc") == "a9993e364706816aba3e25717850c26c9cd0d89d";

  }

  /*
   *
   * Calculate the SHA-1 of an array of big-endian words, and a bit length
   *
   */
  function core_sha1(blockArray){

      var x = blockArray; // append padding
      var w = Array(80);

      var a = 1732584193;

      var b = -271733879;

      var c = -1732584194;

      var d = 271733878;

      var e = -1009589776;

      for (var i = 0; i < x.length; i += 16) // 每次处理512位 16*32
      {

          var olda = a;

          var oldb = b;

          var oldc = c;

          var oldd = d;

          var olde = e;

          for (var j = 0; j < 80; j++) // 对每个512位进行80步操作
          {

              if (j < 16)
                  w[j] = x[i + j];

              else
                  w[j] = rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1);

              var t = safe_add(safe_add(rol(a, 5), sha1_ft(j, b, c, d)), safe_add(safe_add(e, w[j]), sha1_kt(j)));

              e = d;

              d = c;

              c = rol(b, 30);

              b = a;

              a = t;

          }

          a = safe_add(a, olda);

          b = safe_add(b, oldb);

          c = safe_add(c, oldc);

          d = safe_add(d, oldd);

          e = safe_add(e, olde);

      }

      return new Array(a, b, c, d, e);

  }

  /*
   *
   * Perform the appropriate tripvar combination function for the current
   * iteration
   *
   * 返回对应F函数的值
   *
   */
  function sha1_ft(t, b, c, d){

      if (t < 20)
          return (b & c) | ((~ b) & d);

      if (t < 40)
          return b ^ c ^ d;

      if (t < 60)
          return (b & c) | (b & d) | (c & d);

      return b ^ c ^ d; // t<80
  }

  /*
   *
   * Determine the appropriate additive constant for the current iteration
   *
   * 返回对应的Kt值
   *
   */
  function sha1_kt(t){

      return (t < 20) ? 1518500249 : (t < 40) ? 1859775393 : (t < 60) ? -1894007588 : -899497514;

  }

  /*
   *
   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
   *
   * to work around bugs in some JS interpreters.
   *
   * 将32位数拆成高16位和低16位分别进行相加，从而实现 MOD 2^32 的加法
   *
   */
  function safe_add(x, y){

      var lsw = (x & 0xFFFF) + (y & 0xFFFF);

      var msw = (x >> 16) + (y >> 16) + (lsw >> 16);

      return (msw << 16) | (lsw & 0xFFFF);

  }

  /*
   *
   * Bitwise rotate a 32-bit number to the left.
   *
   * 32位二进制数循环左移
   *
   */
  function rol(num, cnt){

      return (num << cnt) | (num >>> (32 - cnt));

  }

  /*
   *
   * The standard SHA1 needs the input string to fit into a block
   *
   * This function align the input string to meet the requirement
   *
   */
  function AlignSHA1(str){

      var nblk = ((str.length + 8) >> 6) + 1, blks = new Array(nblk * 16);

      for (var i = 0; i < nblk * 16; i++)
          blks[i] = 0;

      for (i = 0; i < str.length; i++)

          blks[i >> 2] |= str.charCodeAt(i) << (24 - (i & 3) * 8);

      blks[i >> 2] |= 0x80 << (24 - (i & 3) * 8);

      blks[nblk * 16 - 1] = str.length * 8;

      return blks;

  }

  /*
   *
   * Convert an array of big-endian words to a hex string.
   *
   */
  function binb2hex(binarray){

      var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";

      var str = "";

      for (var i = 0; i < binarray.length * 4; i++) {

          str += hex_tab.charAt((binarray[i >> 2] >> ((3 - i % 4) * 8 + 4)) & 0xF) +

              hex_tab.charAt((binarray[i >> 2] >> ((3 - i % 4) * 8)) & 0xF);

      }

      return str;

  }

  /*
   *
   * calculate MessageDigest accord to source message that inputted
   *
   */
  function calcDigest(){

      var digestM = hex_sha1(document.SHAForm.SourceMessage.value);

      document.SHAForm.MessageDigest.value = digestM;

  }


  /**
   * 合并两个对象
   * a:{attr1:1,attr2:2}, b:{attr3:3} => {attr1:1,attr2:2, attr3:3}
   **/
  function mergeObject(a, b) {
    var result = {};
    for(var name of Object.keys(a)) {
      result[name] = a[name]
    }
    for(var name of Object.keys(b)) {
      result[name] = b[name]
    }
    return result;
  }

  /**
   * 比较两个对象是否相等
   * @return boolean
   **/
  function compareObject(a, b) {
    if(a && b) {
      var str_a = JSON.stringify(a);
      var str_b = JSON.stringify(b);
      if(str_a == str_b) {
        return true;
      }
    }
    return a == b;
  }
  /**
   * 字符串base64加密
   * @return boolean
   **/
  var base64EncodeChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  var base64DecodeChars = new Array(-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57,
    58, 59, 60, 61, -1, -1, -1, -1, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6,
    7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
    25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
    37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1, -1, -1);

  export function b64Encode(str) {
    return btoa(encodeURIComponent(str));
  }

  export function b64Decode(str) {
    return decodeURIComponent(atob(str));
  }

  function base64encode(str) {
    if (!str) {str = ""}
    var out, i, len;
    var c1, c2, c3;
    len = str.length;
    i = 0;
    out = "";

    while(i < len) {
      c1 = str.charCodeAt(i++) & 0xff;

      if(i == len) {
        out += base64EncodeChars.charAt(c1 >> 2);
        out += base64EncodeChars.charAt((c1 & 0x3) << 4);
        out += "==";
        break
      }

      c2 = str.charCodeAt(i++);

      if(i == len) {
        out += base64EncodeChars.charAt(c1 >> 2);
        out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
        out += base64EncodeChars.charAt((c2 & 0xF) << 2);
        out += "=";
        break
      }

      c3 = str.charCodeAt(i++);
      out += base64EncodeChars.charAt(c1 >> 2);
      out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
      out += base64EncodeChars.charAt(((c2 & 0xF) << 2) | ((c3 & 0xC0) >> 6));
      out += base64EncodeChars.charAt(c3 & 0x3F)
    }

    return out
  }

  function base64decode(str) {
    if (!str) {str = ""}
    var c1, c2, c3, c4;
    var i, len, out;
    len = str.length;
    i = 0;
    out = "";

    while(i < len) {
      do {
        c1 = base64DecodeChars[str.charCodeAt(i++) & 0xff]
      } while (i < len && c1 == -1);

      if(c1 == -1)
        break;

      do {
        c2 = base64DecodeChars[str.charCodeAt(i++) & 0xff]
      } while (i < len && c2 == -1);

      if(c2 == -1)
        break;

      out += String.fromCharCode((c1 << 2) | ((c2 & 0x30) >> 4));

      do {
        c3 = str.charCodeAt(i++) & 0xff;

        if(c3 == 61)
          return out;

        c3 = base64DecodeChars[c3]
      } while (i < len && c3 == -1);

      if(c3 == -1)
        break;

      out += String.fromCharCode(((c2 & 0XF) << 4) | ((c3 & 0x3C) >> 2));

      do {
        c4 = str.charCodeAt(i++) & 0xff;

        if(c4 == 61)
          return out;

        c4 = base64DecodeChars[c4]
      } while (i < len && c4 == -1);

      if(c4 == -1)
        break;

      out += String.fromCharCode(((c3 & 0x03) << 6) | c4)
    }

    return out
  }

  function startsWith(str, prefix) {
    if(!!str) {
      return str.slice(0, prefix.length) === prefix;
    } else {
      return false;
    }
  }

  function endsWith(str, suffix) {
    if(!!str) {
      return str.indexOf(suffix, this.length - suffix.length) !== -1;
    } else {
      return false;
    }
  }

  /**
   * Map转换为Object类型
   * @param map
   * @returns {{}}
   * @constructor
   */
  // var MapToObj = function(map){
  //   var obj = {};
  //   for(var [k, v] of map) {
  //     obj[k] = v;
  //   }
  //   return obj;
  // }

  /**
   * Object转化为Map类型
   * @param obj
   * @returns {Map}
   * @constructor
   */
  // var ObjToMap = (obj) => {
  //   var map = new Map();
  //   for(var k of Object.keys(obj)) {
  //     map.set(k, obj[k]);
  //   }
  //   return map;
  // }

  var toString = function (v){
    return !!v ? String(v) : v;
  }

  var trimStr = function (str) {
    if(!str) {
      return '';
    }
    return str.replace(/(^\s*)|(\s*$)/g, "");
  }

  var isEmptyObject =  function (obj) {
    if(typeof obj == 'object') {
      for(var key in obj) {
        return false;
      }
      return true;
    } else return true;
  }

  function stringToBytes(str) {
    var ch, st, re = [];
    for(var i = 0; i < str.length; i++) {
      ch = str.charCodeAt(i); // get char
      st = []; // set up "stack"
      do {
        st.push(ch & 0xFF); // push byte to stack
        ch = ch >> 8; // shift value down by 1 byte
      }
      while (ch);
      re = re.concat(st.reverse());
    }
    return re;
  }

  function bin2String(array) {
    return String.fromCharCode.apply(String, array);
  }

  function inArr(arr, obj) {
    var i = arr.length;
    while (i--) {
      if (arr[i] === obj) {
        return true;
      }
    }
    return false;
  }

  function isBigInArr(arr,obj){
    var i = arr.length;
    while (i--) {
      if (arr[i] <= obj) {
        continue;
      }else{
        return false;
      }
    }
    return true;
  }
  function isSmallInArr(arr,obj){
    var i = arr.length;
    while (i--) {
      if (arr[i] >= obj) {
        continue;
      }else{
        return false;
      }
    }
    return true;
  }


  //解析登录token(不对外)
  export function parseToken(token) {
      var decodeStr = base64decode(token);
      var tokenByteArray = stringToBytes(decodeStr);
      for(var i = 0;i<tokenByteArray.length;i++){
          tokenByteArray[i] = tokenByteArray[i]^0x76;
      }
      var destString = bin2String(tokenByteArray);
      var tokenStringArray =  destString.split(";");
      if(tokenStringArray.length!=4){
          return;
      }else{
          // var lf = liveInfo;
          // var cf = cmsInfo;
          // var imf = cf.imInfo;
          // cf.liveToken = tokenStringArray[0];
          // imf.sdkAppId = tokenStringArray[1];
          // imf.userSig = tokenStringArray[2];
          // imf.imBizNo = tokenStringArray[3];
          // imf.imId = imf.imBizNo + lf.userInfo.uid;
          // IM.setLoginInfo(imf.sdkAppId, imf.imId, imf.userSig,lf.userInfo.userName, lf.userInfo.userImg);
          // success();
            console.log('tokenStringArray',tokenStringArray);
          return tokenStringArray[0];
      }
  }
